import axios from 'axios';

import { webpack } from '@dr.pogodin/react-utils';

import type {
  ListBlogItemsQueryT,
  ListBlogItemsResT,
} from 'server/controllers/blog';

import type * as SSM from 'server/services/blog';

import { P_API_BLOG } from 'utils';

const ss = webpack.requireWeak<typeof SSM>('server/services/blog', import.meta.dirname);

type ArgT = SSM.ListBlogItemsArgT & {
  withTotalCount?: boolean;
};

export async function listBlogItems(arg: ArgT): Promise<ListBlogItemsResT> {
  if (ss) {
    return {
      items: await ss.listBlogItems(arg),
      totalCount: arg.withTotalCount
        ? await ss.countBlogItems(arg)
        : undefined,
    };
  }

  const res = await axios<ListBlogItemsResT>(P_API_BLOG, {
    params: arg satisfies ListBlogItemsQueryT,
  });

  return res.data;
}
